module.exports = __webpack_public_path__ + "static/media/avatar.9ab08b6a.jpg";